import React from "react";
import { Link } from "react-router-dom";
import "./singleRecipiePage.css";
const SingleRecipiePage = (props) => {
  return (
    <>
      <img src={props.currrentImg} alt="img2" />
      <div className="blackComponentSingleRecipie">
        <div className={props.headingcss}>{props.heading}</div>
        {/* {props.currentcolor && props.currentcolor === "white" ? (
            <div className="whiteHeading">{props.heading}</div>
        ) : (
            <div className="blackHeading">{props.heading}</div>
        )} */}
          <p className={props.pcss}>{props.text}</p>
        {/* {props.currentcolor && props.currentcolor === "white" ? (
          <p className="whiteP">{props.text}</p>
        ) : (
          <p className="blackP">{props.text}</p>
        )} */}

        <div className="flex">
          {props.link1 ? (
            <Link
              to={`${props.link1}`}
              className="removeLinkDecoration"
            >
              <button className={props.linkClass}>{props.link1Text}</button>
            </Link>
          ) : (
            ""
          )}
          {props.link2 ? (
            <Link
              to={`${props.link2}`}
              target="_blank"
              className="removeLinkDecoration"
            >
              <button className={props.linkClass}>Buy Now</button>
            </Link>
          ) : (
            ""
          )}
        </div>
      </div>
      {props.sideImg ? (
        <div className="sideImg">
          <img src={props.sideImg} className="sideimage" alt="sideImg" />
        </div>
      ) : (
        ""
      )}
    </>
  );
};

export default SingleRecipiePage;
